/*
 *  This file hrone-idle.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2024
 *  (C) 2015-2024. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */


import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HroneIdleService {
  openLockScreePopup = signal<boolean>(false);
  sessionOutMilliSeconds!: number;
  lockTimeCellInterval: string | number | undefined | NodeJS.Timeout;
  triggerTimes: number[] = [120000, 90000, 60000, 30000, 5000]
  currTime = Date.now();
  isScreenLockIdle:number | false = false;
  isApiCall = false;
  startWatchingActivity(sessionTimeOut: number): void {
    this.sessionOutMilliSeconds = sessionTimeOut * 1000;
    if (this.lockTimeCellInterval) {
      this.stopUpdateLockTime();
    }
    localStorage.removeItem('isAppLock')
    this.startUpdateLockTime();
  }
  startUpdateLockTime(): void {
    this.currTime = Date.now();
    this.lockTimeCellInterval = setInterval(() => {
      let newCurrTime = Date.now();
      let diff = newCurrTime - this.currTime;
      if (diff <= 1300) {
        this.sessionOutMilliSeconds -= 1000;
      } else {
        this.sessionOutMilliSeconds -= Math.round(diff / 1000) * 1000;
      }
      this.currTime = newCurrTime;
      let token = localStorage.getItem('authlogin');
      if (!token) {
        this.stopUpdateLockTime();
        return
      }
      if (this.triggerTimes.includes(this.sessionOutMilliSeconds)) {
        localStorage.setItem('remainingIdleTime', JSON.stringify(this.sessionOutMilliSeconds))
      } else if (!this.sessionOutMilliSeconds || this.sessionOutMilliSeconds < 1000) {
        this.stopUpdateLockTime();
        this.gotoLockMode();
      }
    }, 1000)
  }
  stopUpdateLockTime(): void {
    clearInterval(this.lockTimeCellInterval);
    this.lockTimeCellInterval = undefined;
  }
  gotoLockMode(): void {
    localStorage.setItem('isAppLock', JSON.stringify(true))
    this.openLockScreePopup.update((value) => !value);
  }
}
